import { ModalType, selectModalProps } from '../slices/modal.slice';
import React, { Suspense, useEffect, useState } from 'react';

import CustomModal from '../components/Modal/Modal';
import LoadingOverlay from '../components/LoadingOverlay';
import { Navigate } from 'react-router-dom';
import { PublicRouteType } from '../types/common';
import { get } from 'lodash';
import { getStorageValue } from '../utils/cookies';
import modals from '../screens/Modals';
import { selectIsLoading } from '../slices/loading.slice';
import { useAppSelector } from '../store/hooks';

const PublicRoute = ({ children }: PublicRouteType) => {
  const accessLoginToken = getStorageValue('access_token');
  const { modalName, modalOpen = false, styles: ModalStyles }: ModalType = useAppSelector(selectModalProps);
  const [ModalComponent, setModalComponent] = useState<React.ReactNode>(null);
  const isLoading = useAppSelector(selectIsLoading);
  useEffect(() => {
    const fetchModalComponent = async () => {
      const Component = await get(modals, modalName, React.Fragment);
      setModalComponent(<Component />);
    };
    fetchModalComponent();
  }, [modalName]);
  if (accessLoginToken) return <Navigate to='/' />
  return (
    <>
      {children}
      <Suspense fallback={<LoadingOverlay isLoading={true} />}>
        <CustomModal open={modalOpen} styles={ModalStyles}>
          {ModalComponent}
        </CustomModal>
      </Suspense>
      <LoadingOverlay isLoading={isLoading} />
    </>
  );
};

export default PublicRoute;
